// ─────────────────────────────────────────
//  CONFETTI
// ─────────────────────────────────────────
// npm-paket via dynamisk import (code-split) — tidigare injicerades
// confetti/pdf.js/xlsx från CDN i <head> för varje besökare, utan SRI
let confetti = null;
async function ensureConfetti() {
  if (!confetti) {
    const mod = await import("canvas-confetti");
    confetti = mod.default;
  }
  return confetti;
}

function celebratePerfect() {
  ensureConfetti().then(fire => fire && runPerfect());
}
function runPerfect() {
  if (!confetti) return;
  const duration = 3000;
  const end = Date.now() + duration;
  const colors = ["#f5c842", "#ffd700", "#ffed4e"];
  
  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  }());
}

function celebrateGood() {
  ensureConfetti().then(fire => fire && fire({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ["#22c55e", "#3b82f6", "#f5c842", "#ec4899"]
  }));
}

function celebrateStandard() {
  ensureConfetti().then(fire => fire && fire({
    particleCount: 50,
    spread: 50,
    origin: { y: 0.6 },
    colors: ["#6366f1", "#8b5cf6", "#ec4899"]
  }));
}

export { ensureConfetti, celebratePerfect, runPerfect, celebrateGood, celebrateStandard };
